import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as TimelineService from "_services/timeline-service";

const initialState = {
    dashboardTaskList: [],
    dashboardEmployeeList: [],

    // airportLocationsAnalytics flags
    airportLocationsAnalytics: null,
    getAirportLocationsAnalyticsStatus: "idle",
    getAirportLocationsAnalyticsError: null,

    selectedDashboardLocation: null,


    employeesLatestActivity: [],
    getEmployeesLatestActivityStatus: "idle",
    getEmployeesLatestActivityError: null,

    locationsData: [],
    getLocationsDataStatus: "idle",
    getLocationsDataError: null,
    getLocationLastUpdate: null,

};

export const getAirportLocationsAnalytics = createAsyncThunk(
    "timelineDashboard/getAirportLocationsAnalytics",
    async (params) => {
        return TimelineService.getAirportLocationsAnalytics(params);
    }
);
export const getEmployeesLatestActivity = createAsyncThunk(
    "timelineDashboard/getEmployeesLatestActivity",
    async (params) => {
        return TimelineService.getEmployeesLatestActivity(params);
    }
);
export const getLocationsData = createAsyncThunk(
    "timelineDashboard/getLocationsData",
    async (params) => {
        return TimelineService.getLocationsData(params);
    }
);

const timelineControlSlice = createSlice({
    name: "timelineDashboard",
    initialState,
    reducers: {
        reset: (state) => initialState,
        setDashboardTaskList: (state, action) => {
            state.dashboardTaskList = action.payload;
        },
        setDashboardEmployeeList: (state, action) => {
            state.dashboardEmployeeList = action.payload;
        },
        resetAirportLocationsAnalytics: (state) => {
            state.getAirportLocationsAnalyticsStatus = "idle";
            state.getAirportLocationsAnalyticsError = null;
        },
        setSelectedDashboardLocation: (state, action) => {
            state.selectedDashboardLocation = action.payload;
        },
        resetGetLocationsDataFlags: (state, action) => {
            state.getLocationsDataStatus = "idle";
            state.getLocationsDataError = null;
        },
        resetLocationData: (state) => {
            state.locationsData = [];
        }

    },
    extraReducers: {
        [getAirportLocationsAnalytics.pending]: (state, action) => {
            state.getAirportLocationsAnalyticsStatus = "loading";
        },
        [getAirportLocationsAnalytics.fulfilled]: (state, action) => {
            state.getAirportLocationsAnalyticsStatus = "succeeded";
            state.airportLocationsAnalytics = action.payload;
        },
        [getAirportLocationsAnalytics.rejected]: (state, action) => {
            state.getAirportLocationsAnalyticsStatus = "failed";
            state.getAirportLocationsAnalyticsError = action.error.message;
        },

        [getEmployeesLatestActivity.pending]: (state, action) => {
            state.getEmployeesLatestActivityStatus = "loading";
        },
        [getEmployeesLatestActivity.fulfilled]: (state, action) => {
            state.getEmployeesLatestActivityStatus = "succeeded";
            state.employeesLatestActivity = action.payload;
        },
        [getEmployeesLatestActivity.rejected]: (state, action) => {
            state.getEmployeesLatestActivityStatus = "failed";
            state.getEmployeesLatestActivityError = action.error.message;
        },

        [getLocationsData.pending]: (state, action) => {
            state.getLocationsDataStatus = "loading";
        },
        [getLocationsData.fulfilled]: (state, action) => {
            state.getLocationsDataStatus = "succeeded";
            state.getLocationLastUpdate = new Date().toLocaleTimeString();

            //console.log('payload ', action.payload)

            state.locationsData = action.payload;
        },
        [getLocationsData.rejected]: (state, action) => {
            state.getLocationsDataStatus = "failed";
            state.getLocationsDataError = action.error.message;
        },

    },
});

export const {
    reset,
    setDashboardTaskList,
    setDashboardEmployeeList,
    resetAirportLocationsAnalytics,
    setSelectedDashboardLocation,
    resetGetLocationsDataFlags,
    resetLocationData
} = timelineControlSlice.actions;

export const selectLastLocationUpdate = (state) => state.timelineDashboard.getLocationLastUpdate;

export const selectDashboardTaskList = (state) => state.timelineDashboard.dashboardTaskList;
export const selectDashboardEmployeeList = (state) => {
    if (!Array.isFullArray(state.timelineDashboard.dashboardEmployeeList)) return [];

    let sortedEmployeeList = [...state.timelineDashboard.dashboardEmployeeList];
    console.log(sortedEmployeeList, "sortedEmployeeList...")
    // Use the sort() method to sort the list
    sortedEmployeeList.sort((a, b) => {
        if (a != null && b != null && a.status != null && b.status != null) {
            if (a.status === "online" && b.status === "offline") {
                return -1; // "online" comes before "offline"
            } else if (a.status === "offline" && b.status === "online") {
                return 1; // "offline" comes after "online"
            } else {
                // If both have the same status or both are different statuses, maintain the original order
                return 0;
            }
        }
    });

    return sortedEmployeeList

};

export const selectLocationEmployeeCount = (state) => {
    if (!Array.isFullArray(state.timelineDashboard.dashboardEmployeeList)) return 0;
    if (!state.timelineDashboard.selectedDashboardLocation) return 0;
    let counter = 0
    let tempEmployees = state.timelineDashboard.dashboardEmployeeList;
    tempEmployees?.forEach((employee) => {
        if (employee?.workZone && Array.isFullArray(employee?.workZone?.location)) {
            let tempEmployeeLocation = employee?.workZone?.location?.map((item) => item?.locationId);
            if (Array.isFullArray(tempEmployeeLocation) && tempEmployeeLocation?.includes(state?.timelineDashboard?.selectedDashboardLocation)) {
                counter++
            }
        }
    })

    return counter
};


export const selectDashboardAvailableEmployeeNum = (state) => {
    // check if there is employee list or not 
    if (!Array.isFullArray(state.timelineDashboard.dashboardEmployeeList)) return 0;
    let tempAvailableList = state.timelineDashboard.dashboardEmployeeList;

    // check if there is no task list all online employees are available
    if (!Array.isFullArray(state.timelineDashboard.dashboardTaskList)) return tempAvailableList?.filter((employee) => employee.status !== "offline")?.length ?? 0;

    // active tasks array
    let activeTasks = state.timelineDashboard.dashboardTaskList?.filter((task) => task?.active == true);

    // new Set removes the similar employeeId and make each element uniq 
    let activeEmployeesIDS = [...new Set(activeTasks?.map((task) => task?.employeeId))];
    return tempAvailableList?.filter((employee) => !activeEmployeesIDS?.includes(employee.employeeId) && employee.status !== "offline")?.length ?? 0;//TODO, later we should depend on available only
};

export const selectDeparturesTasksNum = (state) => {
    const iata = state?.user?.dbInfo?.details?.authority
    if (!Array.isFullArray(state.timelineDashboard.dashboardTaskList)) return 0;
    else return state.timelineDashboard.dashboardTaskList?.filter((task) => task?.flightInformation?.departureAirport === iata)?.length
};

export const selectArrivalsTasksNum = (state) => {
    const iata = state?.user?.dbInfo?.details?.authority
    if (!Array.isFullArray(state.timelineDashboard.dashboardTaskList)) return 0;
    else return state.timelineDashboard.dashboardTaskList?.filter((task) => task?.flightInformation?.arrivalAirport === iata)?.length
};

export const selectTotalTasksNum = (state) => {
    if (!Array.isFullArray(state.timelineDashboard.dashboardTaskList)) return 0;
    else return state.timelineDashboard.dashboardTaskList?.length
};

export const selectActiveTasksNum = (state) => {
    if (!Array.isFullArray(state.timelineDashboard.dashboardTaskList)) return 0;
    else return state.timelineDashboard.dashboardTaskList?.filter((task) => task?.active === true)?.length
};

export const selectCompletedTasksNum = (state) => {
    if (!Array.isFullArray(state.timelineDashboard.dashboardTaskList)) return 0;
    else return state.timelineDashboard.dashboardTaskList?.filter((task) => task?.completed === true)?.length
};

export const selectAirportLocationsAnalytics = (state) => state.timelineDashboard.airportLocationsAnalytics;
export const selectGetAirportLocationsAnalyticsStatus = (state) => state.timelineDashboard.getAirportLocationsAnalyticsStatus;
export const selectSelectedDashboardLocation = (state) => state.timelineDashboard.selectedDashboardLocation;
export const selectEmployeesLatestActivity = (state) => state.timelineDashboard.employeesLatestActivity;
export const selectGetEmployeesLatestActivityStatus = (state) => state.timelineDashboard.getEmployeesLatestActivityStatus;

export const selectLocationsData = (state) => state.timelineDashboard.locationsData;

export const selectGetLocationsDataStatus = (state) => state.timelineDashboard.getLocationsDataStatus;

export default timelineControlSlice.reducer;
